import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { CurriculumTreeYearInterface } from '../+models';

export const CURRICULUM_TREE_YEAR_SERVICE_TOKEN = new InjectionToken('CurriculumTreeYearServiceInterface');

export interface CurriculumTreeYearServiceInterface {
  getAllForUser(userId: number): Observable<CurriculumTreeYearInterface[]>;
}
